import { ReactElement } from 'react';
import { PanelPropTypes } from '../../types/propTypes/PanelPropTypes';
import { sanitizeText } from '../../utilities/helperUtilities';
import './Panel.css';

const Panel = ({
  panelType,
  heading,
  children,
  className,
  headerClassName,
}: PanelPropTypes): ReactElement => {
  return (
    <div
      data-testid={`panel-container-${sanitizeText(heading)}`}
      className={`panel-block ${className || ''}`}
    >
      <div
        role="panel-header"
        className={`panel-heading panel-${panelType} ${headerClassName || ''}`.trim()}
      >
        {heading}
      </div>
      <div role="panel-content" className="panel-content">
        {children}
      </div>
    </div>
  );
};

export default Panel;
